// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"M4-z","dimensionLabel":"N4-z","styleChooserControlWrapper":"O4-z","styleChooserControl":"P4-z","disabled":"Q4-z","giftCard":"R4-z","styleChooserText":"S4-z"};